module.exports = __webpack_public_path__ + "webwave-3.png?3a2032702cecec43087dc4e2e63363fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/webwave-3.png
// module id = 60S/
// module chunks = 50